module.exports = __webpack_public_path__ + "img/find-two.d987b066.webp";